<template lang="pug">
.container-layout-padrao
  Nav(:breadcrumbText="breadcrumbText")
  .pagina-atual(v-if="$route.name !== 'Perfil'")
    ButtonPadrao(
      @click="$router.push('/espaco-nexa/perfil')"
      variant="negative"
    ) Voltar ao Perfil
  .router-view
    router-view
</template>

<script>
import { mapActions } from 'vuex';
import Nav from '@/components/Nav.vue'
import ButtonPadrao from '@/components/ui/ButtonPadrao.vue';

export default {
  components: {
    Nav,
    ButtonPadrao
  },

  computed: {
    breadcrumbText() {
      const routeName = this.$route.name
      if (routeName === 'Perfil') return { full: 'Perfil Desenvolvedor' }
      if (routeName === 'InformacoesPessoais') return { path: 'Editar Perfil', current: 'Informações Pessoais' }
      if (routeName === 'TopHabilidades') return { path: 'Editar Perfil', current: 'Top Habilidades' }
      if (routeName === 'OutrasHabilidades') return { path: 'Editar Perfil', current: 'Todas Habilidades' }
      if (routeName === 'Projetos') return { full: 'Projetos' }
      if (routeName === 'Contato') return { full: 'Contato' }
      return { full: routeName || '' }
    }
  },

  async created() {
    await this.loadUserData()
  },

  methods: {
    ...mapActions({
      fetchClasses: 'classes/fetchClasses',
      fetchUsuarioById: 'usuario/fetchUsuarioById'
    }),
    
    async loadUserData() {
      // Busca o ID do usuário do localStorage
      let userData = localStorage.getItem('user-nexa')
      
      if (!userData) return
      
      try {
        const userObj = JSON.parse(userData)
        const userId = userObj?.id
        
        if (userId) {
          // Sempre busca os dados completos do usuário
          await this.fetchUsuarioById(userId)
        }
      } catch (error) {
        console.error('Erro ao carregar dados do usuário:', error)
        // Se houver erro no parse, limpa e força login novamente
        localStorage.removeItem('user-nexa')
      }
    }
  },
}

</script>

<style lang="scss">
.container-layout-padrao {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: $corPreto;
  color: $corBranco;
  margin: 0 auto;
  padding: 0 16px 60px 16px;
  box-sizing: border-box;
  overflow: auto;

  .pagina-atual{
    max-width: 1360px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    margin: 80px 0 32px 0;
  }
  
  .router-view{
    max-width: 1360px;
    width: 100%;
  }
}

.container-layout-padrao, .container-layout-padrao * {
  font-family: "Inter", sans-serif !important;
}

@media (max-width: 768px) {
  .container-layout-padrao {
    .pagina-atual {
      margin-top: 90px;
      margin-bottom: 12px;
    }
    padding-bottom: 100px;
  }
}
</style>